import {
	collection,
	onSnapshot,
	query,
	where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { AuthorComment } from "../types/comments.types";

export function useAuthorComments(broadcastId: string | null, authorId: string | null): AuthorComment[] {
	const [comments, setComments] = useState<AuthorComment[]>([]);

	useEffect(() => {
		if (!broadcastId || !authorId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "comments"),
			where("authorId", "==", authorId),
		);

		return onSnapshot(q, (snap) => {
			const docs = snap.docs.map((d) => ({
				id: d.id,
				...(d.data() as Omit<AuthorComment, "id">),
			}));
			docs.sort((a, b) => b.date.localeCompare(a.date));
			setComments(docs);
		});
	}, [broadcastId, authorId]);

	return comments;
}
